<div id="click2call-component" fxLayout="column" class="click2call-component">

  <gt-dialog-header [message]="message" (closing)="cancelClicked()" icon="phone"></gt-dialog-header>

  <div mat-dialog-content fxLayout="column" style="min-width: 300px;" fxLayoutGap="16px">

    <gt-phone-number-selector fxFill (phoneNumberSelected)="setPhoneNumber($event.fullNumber)"
                              (accepted)="okClicked($event)" 
                              [allowOtherNumber]="true"
                              [allowShortNumber]="true"
                              [searchMainNumbers]="true"
                              [searchEndUsers]="true"
                              [searchContacts]="true"
                              [searchMainNumberCallLogs]="false"
                              [shouldFocus]="true"
                              [initialValue]="initialPhoneNumber"
                              [canEdit]="canEdit"></gt-phone-number-selector>

    <gt-display-number-selector (displayNumberSelected)="displayNumberChanged($event)"></gt-display-number-selector>
  </div>

  <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
    <button mat-button id="ok-button" (click)="okClicked()" color="primary" [disabled]="!phoneNumber" gtDisableWhenNotloggedin>{{ 'global.ok' | translate }}</button>
    <button mat-button id="cancel-button" (click)="cancelClicked()" color="primary">{{ 'global.cancel' | translate }}</button>
  </div>
</div>
